module.exports = __webpack_public_path__ + "static/media/Google_Meet-Logo.wine.5d17eea6.svg";